export const SOLUTION_EXTRAS = {
  "content-syndication": {
    stats: [
      ["3–5", "Business days to campaign launch"],
      ["100%", "ICP-filtered asset downloads"],
      ["60+", "Contextual publication hubs"],
    ],
  },
  "qualified-leads": {
    stats: [
      ["4", "Qualification tiers — MQL to CCL"],
      ["100%", "Quality & replacement guarantee"],
      ["3–12 mo", "Verified buying timelines"],
    ],
  },
  "account-based-marketing": {
    stats: [
      ["100%", "Target account list matching"],
      ["6–12", "Stakeholders mapped per account"],
      ["1,000s", "External intent topics monitored"],
    ],
  },
  "technographic-targeting": {
    stats: [
      ["15,000+", "Technology install bases tracked"],
      ["140M+", "Executive profiles cross-referenced"],
      ["90+", "Markets with install intelligence"],
    ],
  },
  "webinar-lead-generation": {
    stats: [
      ["100%", "Guaranteed registrant quotas"],
      ["3-touch", "Pre-event nurture cadence"],
      ["48h", "Post-event data delivery"],
    ],
  },
  "b2b-data-services": {
    stats: [
      ["30%+", "Annual data decay reversed"],
      ["0%", "Bounce tolerance at delivery"],
      ["API", "Webhook & secure batch delivery"],
    ],
  },
};

export const LEAD_TIERS = [
  {
    level: "Marketing Qualified Lead (MQL)",
    criteria:
      "Verified target account contact who opts in to download strategic digital assets and confirms interest in the solution category.",
    use: "Nurture streams, marketing automation workflows, retargeting campaigns, and brand awareness building.",
  },
  {
    level: "High-Quality Lead (HQL)",
    criteria:
      "Prospect meets strict ICP parameters, engages with multiple content pieces, and answers custom qualifying discovery questions.",
    use: "SDR cadence initiation, product tier introduction, and inbound follow-up prioritization.",
  },
  {
    level: "BANT Qualified Lead",
    criteria:
      "Prospect confirms acute business Need, verified Budget availability, direct purchasing Authority, and a defined deployment Timeline (typically 3–12 months).",
    use: "Direct Account Executive (AE) pipeline handoff, active opportunity creation, and accelerated deal progression.",
  },
  {
    level: "Confirmed Call-Back (CCL)",
    criteria:
      "Target decision-maker explicitly requests an exploratory call with your solution specialist at a mutually agreed date and time.",
    use: "Calendarized discovery meetings, high-conversion outbound sales acceleration, and rapid deal closure.",
  },
];
